// extracted by mini-css-extract-plugin
module.exports = {"actionContainer":"productcard_actionContainer__14a0M","col12":"productcard_col12__2kQKj","latestblogTitle":"productcard_latestblogTitle__pm0gE"};